import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconWhatsApp = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-whatsapp' + (className ? ` ${className}` : '')}
            fill={fill}
            height='14'
            viewBox='0 0 14 14'
            width='14'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M7.00002 0C3.1403 0 4.51722e-05 3.14026 4.51722e-05 7C4.51722e-05 8.20522 0.311392 9.39035 0.901825 10.4361L0.011306 13.6135C-0.0179113 13.7179 0.010393 13.8299 0.085871 13.9075C0.144001 13.9674 0.223131 14 0.304392 14C0.32874 14 0.353392 13.997 0.377435 13.9912L3.6936 13.1697C4.70616 13.7133 5.84655 14 7.00002 14C10.8597 14 14 10.8597 14 7C14 3.14026 10.8597 0 7.00002 0ZM10.5213 9.47009C10.3716 9.88461 9.65332 10.2629 9.30819 10.3137C8.99836 10.3591 8.60637 10.3786 8.17602 10.2434C7.91519 10.1613 7.58041 10.0523 7.15159 9.86939C5.34894 9.10061 4.17173 7.3083 4.08164 7.18991C3.99186 7.07152 3.34786 6.22787 3.34786 5.3547C3.34786 4.48152 3.81199 4.05209 3.97695 3.87435C4.1419 3.69661 4.33638 3.65217 4.45629 3.65217C4.5762 3.65217 4.69581 3.6537 4.80081 3.65857C4.91129 3.66404 5.05951 3.61687 5.20529 3.96322C5.35503 4.3187 5.71446 5.19187 5.7589 5.28104C5.80394 5.36991 5.83377 5.4737 5.77411 5.59209C5.71446 5.71048 5.68464 5.78443 5.59455 5.88822C5.50446 5.992 5.40585 6.11952 5.3249 6.19926C5.23481 6.28783 5.14138 6.3837 5.24607 6.56143C5.35077 6.73917 5.71142 7.32017 6.24585 7.7907C6.93215 8.39513 7.51133 8.58261 7.69089 8.67148C7.87045 8.76035 7.97545 8.74543 8.08015 8.62704C8.18484 8.50835 8.52936 8.10874 8.64897 7.9313C8.76858 7.75387 8.88849 7.78309 9.05345 7.84243C9.21841 7.90148 10.1019 8.33061 10.2815 8.41948C10.4611 8.50835 10.581 8.55278 10.626 8.62674C10.6711 8.70039 10.6711 9.05587 10.5213 9.47009Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconWhatsApp;
